// extracted by mini-css-extract-plugin
module.exports = {"container":"container-module--container--3C57J","articleContainer":"container-module--articleContainer--2wVa7"};